import React, { useCallback, useEffect, useState } from "react";

import { useLocation, useParams } from "react-router-dom";
import Sidebar from "../../../../components/AdminComponents/SideNav";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import {
  //   capitalizeWords,
  //   formatDateWithSuffix,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
// import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { CustomerTopLevel } from "../../../../components/AdminComponents/MenuItems";
import { Card, Typography, Divider, Menu, Select, Tooltip } from "antd";
import {
  FileTextOutlined,
  ReadOutlined,
  TeamOutlined,
  BranchesOutlined,
} from "@ant-design/icons";
// import "../courseStyles.css";

import axiosInstance from "../../../../api/Axios";

import { useSelector } from "react-redux";

import { accessImpersontate } from "../../../../config";
import Summary from "./Summary";
import Events from "./Events";
import Users from "./Users";
import Subscriptions from "./Subscriptions";
import CustomerRightEdit from "./CustomerRightEdit";
// import dayjs from "dayjs";
// const dateFormat = "MMM DD YYYY";
const { Title } = Typography;
// eslint-disable-next-line no-unused-vars
const { Option } = Select;

const CustomerEditContainer = () => {
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const [activeView, setActiveView] = useState("summary");
  const [data1, setData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CustomerTopLevel : CustomerTopLevel;
  const userInfo = useSelector((state) => state.user);
  // Original code - commented out to allow access in production when impersonating
  // const ImpersonateAccess = !accessImpersontate(
  //   userInfo?.data?.impersonate_acc
  // );
  // Always allow access for Customer impersonate section
  const ImpersonateAccess = true;
  const LoadUser = useCallback(async () => {
    try {
      const res = await axiosInstance.get(
        `customer/customerslist/?parent_key_id=${userInfo?.data?.organization?.id}&status=True&id=${id}`
      );
      setData1(res?.data?.[0] || {});
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [id, userInfo?.data?.organization?.id]);

  useEffect(() => {
    LoadUser();
  }, [LoadUser]);
  const sharedProps = { data1, loading, LoadUser, ImpersonateAccess };
  const [subZero, setSubZero] = useState(false);
  const [eventsDisabled, setEventsDisabled] = useState(false);
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    if (data1?.org_subscriptions <= 0) {
      setSubZero(true);
    } else {
      setSubZero(false);
    }
  }, [data1?.org_subscriptions]);
  const LoadSubscriptions = useCallback(async () => {
    try {
      const res = await axiosInstance.get(
        `/customer/customersubscriptions/?organization_id=${id}`
      );
      const subsData = res?.data?.data || [];
      setSubscriptions(subsData);
      // Get unique application names from subscriptions
      const applicationNames = subsData.map((sub) => sub.application_name).filter(Boolean);
      const uniqueApps = [...new Set(applicationNames)];
      
      // Events visibility logic:
      // - Show Events if customer has "Trak Learning" subscription (even if they have other subscriptions)
      // - Hide Events for "TraineryLMS" subscription (only if no Trak Learning)
      // - Hide Events for "Trak Coaching" subscription (only if no Trak Learning)
      const hasTrakLearning = uniqueApps.includes("Trak Learning");
      const hasTraineryLMS = uniqueApps.includes("TraineryLMS");
      const hasTrakCoaching = uniqueApps.includes("Trak Coaching");
      
      // Show Events if Trak Learning is present (regardless of other subscriptions)
      // Hide Events only if no Trak Learning AND has TraineryLMS or Trak Coaching
      if (hasTrakLearning) {
        // Show Events tab if Trak Learning subscription exists
        setEventsDisabled(false);
      } else if (hasTraineryLMS || hasTrakCoaching) {
        // Hide Events if only TraineryLMS or Trak Coaching (without Trak Learning)
        setEventsDisabled(true);
      } else {
        // If no subscriptions or none of the above, disable events
        setEventsDisabled(true);
      }
    } catch (err) {
      console.log(err);
      // Default to disabled if error fetching subscriptions
      setEventsDisabled(true);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      LoadSubscriptions();
    }
  }, [LoadSubscriptions, id]);

  // Reset activeView to summary if events becomes disabled while viewing events
  useEffect(() => {
    if (eventsDisabled && activeView === "events") {
      setActiveView("summary");
    }
  }, [eventsDisabled, activeView]);

  const renderActiveView = () => {
    // If user tries to access events when disabled, redirect to summary
    if (activeView === "events" && eventsDisabled) {
      return <Summary {...sharedProps} />;
    }
    switch (activeView) {
      case "summary":
        return <Summary {...sharedProps} />;
      case "events":
        return <Events {...sharedProps} />;
      case "users":
        return <Users {...sharedProps} />;
      case "subscriptions":
        return <Subscriptions {...sharedProps} />;
      default:
        return <Summary {...sharedProps} />;
    }
  };
  console.log(data1?.org_subscriptions, data1);
  const menuItems = [
    {
      key: "summary",
      label: (
        <div className="menu-vertical-item">
          <FileTextOutlined style={{ fontSize: "22px" }} />
          <div>Profile</div>
        </div>
      ),
      disabled: false,
    },
    {
      key: "subscriptions",

      label: (
        <div className="menu-vertical-item">
          <span style={{ display: "flex", alignItems: "center" }}>
            <BranchesOutlined style={{ fontSize: "22px" }} />
            {data1?.org_subscriptions > 0 && (
              <span className="department-count-badge">
                {data1?.org_subscriptions}
              </span>
            )}
          </span>
          <div style={{ display: "inline-block" }}>Access</div>
        </div>
      ),
    },
    {
      key: "users",
      disabled: subZero,
      label: (
        <Tooltip
          title={
            subZero
              ? "Please add at least one access to make this customer available for user assignment"
              : ""
          }
        >
          <div className="menu-vertical-item">
            <span style={{ display: "flex", alignItems: "center" }}>
              <TeamOutlined
                style={{ fontSize: "22px", color: subZero ? "gray" : "" }}
              />
              {data1?.no_of_learners > 0 && (
                <span className="department-count-badge">
                  {data1?.no_of_learners}
                </span>
              )}
            </span>
            <div style={{ display: "inline-block" }}>Users</div>
          </div>
        </Tooltip>
      ),
    },
    // Only show Events tab for Trak Learning subscription (when eventsDisabled is false)
    !eventsDisabled && {
      key: "events",
      label: (
        <div className="menu-vertical-item">
          <span style={{ display: "flex", alignItems: "center" }}>
            <ReadOutlined style={{ fontSize: "22px" }} />
            {data1?.no_of_events > 0 && (
              <span className="department-count-badge">
                {data1?.no_of_events}
              </span>
            )}
          </span>
          <div style={{ display: "inline-block" }}>Events</div>
        </div>
      ),
    },
  ].filter(Boolean); // Filter out falsy values (when eventsDisabled is true, the Events item will be removed)
  return (
    <WrapperComponent props={wrapperProps}>
      <div
        style={{
          background: "#f4f4f4",
          width: "100%",
          height: remainingViewportHeight(10),
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px",
          overflowY: "auto",
          gap: "24px",
          marginTop: "50px",
        }}
      >
        <div style={{ flexBasis: "10%", height: "100%" }}>
          <Card
            bordered
            hoverable
            style={{
              height: "100%",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
              display: "flex",
              flexDirection: "column",
              padding: "5px",
              background: "#F9FBFC",
            }}
            className="no-padding-no-margin"
          >
            <Title
              // level={}
              style={{
                fontSize: "15.5px",
                textAlign: "center",
                width: "100%",
                // display: "block",
                fontWeight: "600",
                letterSpacing: 0.5,
                color: "#333333",
                marginTop: "28.5px",
              }}
            >
              Edit Customer
            </Title>

            <Divider />
            <div style={{ paddingInline: "5px" }}>
              <Menu
                className="modern-sidebar-menu"
                mode="inline"
                selectedKeys={[activeView]}
                onClick={({ key }) => {
                  // Prevent navigation to events if disabled
                  if (key === "events" && eventsDisabled) {
                    return;
                  }
                  setActiveView(key);
                }}
                style={{
                  flex: 1,
                  overflowY: "auto",
                  borderRight: "none",
                  width: "100%",
                  background: "transparent",
                }}
                items={menuItems}
              />
            </div>
          </Card>
        </div>
        <div
          style={{
            flexBasis: "75%",
            display: "flex",
            overflowX: "auto",
          }}
        >
          {renderActiveView()}
        </div>
        <div style={{ flexBasis: "15%", height: "100%", marginRight: "15px" }}>
          <CustomerRightEdit
            data1={data1}
            loading={loading}
            LoadUser={LoadUser}
            ImpersonateAccess={ImpersonateAccess}
          />
        </div>
      </div>
    </WrapperComponent>
  );
};

export default CustomerEditContainer;
